// Fatia S5b: lista completa de notificações do usuário (todas as contas).
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { CheckCheck, Settings2 } from 'lucide-react'
import type { NotificationDto } from '@impulso/shared/api/notifications'
import { useSession } from '../../lib/session'
import { Empty, ErrorState, Loading, PageHead, Tabs } from '../../ui'
import { useToast } from '../../ui/toast'
import { errorMessage } from '../../lib/api'
import { useMarkAllRead, useMarkRead, useNotifications } from '../../features/notifications/api'
import { NotificationItem } from '../../features/notifications/NotificationItem'

export default function Notifications() {
  const [filter, setFilter] = useState<'all' | 'unread'>('all')
  const q = useNotifications({ unread: filter === 'unread', limit: 100 })
  const markRead = useMarkRead()
  const markAll = useMarkAllRead()
  const navigate = useNavigate()
  const toast = useToast()
  const { me } = useSession()
  const companies = (me?.accounts ?? []).flatMap((a) => a.companies.map((c) => ({ id: c.id, name: c.name })))

  const open = (n: NotificationDto) => {
    if (!n.read) markRead.mutate(n.id)
    if (n.link?.startsWith('/')) navigate(n.link)
  }

  const unread = q.data?.unread ?? 0
  return (
    <>
      <PageHead title="Notificações" sub={unread > 0 ? `${unread} não lida${unread === 1 ? '' : 's'}` : 'Tudo em dia.'}>
        {unread > 0 && (
          <button
            className="btn"
            disabled={markAll.isPending}
            onClick={() => markAll.mutate(undefined, { onSuccess: () => toast('Todas marcadas como lidas.'), onError: (e) => toast(errorMessage(e)) })}
          >
            <CheckCheck size={16} /> Marcar todas como lidas
          </button>
        )}
      </PageHead>

      <div className="row wrap between" style={{ marginBottom: 16, gap: 12 }}>
        <Tabs value={filter} onChange={setFilter} options={[{ value: 'all', label: 'Todas' }, { value: 'unread', label: 'Não lidas' }]} />
        {companies.length > 0 && (
          <label className="row small" style={{ gap: 8 }}>
            <Settings2 size={15} />
            <select
              className="select"
              style={{ width: 'auto', maxWidth: 240, padding: '7px 10px' }}
              aria-label="Escolher quais avisos receber"
              value=""
              onChange={(e) => e.target.value && navigate(`/app/${e.target.value}/config/avisos`)}
            >
              <option value="">Escolher quais avisos receber…</option>
              {companies.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>
        )}
      </div>

      {q.isLoading && <div className="card"><Loading lines={5} /></div>}
      {q.error && <ErrorState error={q.error} onRetry={() => q.refetch()} />}
      {q.data && q.data.items.length === 0 && (
        <Empty title={filter === 'unread' ? 'Nenhuma notificação não lida' : 'Nenhuma notificação ainda'}>
          Avisamos aqui (e por e-mail, se você quiser) quando algo importante acontecer com seus anúncios.
        </Empty>
      )}
      {q.data && q.data.items.length > 0 && (
        <div className="card flush">
          {q.data.items.map((n) => <NotificationItem key={n.id} n={n} onOpen={open} />)}
        </div>
      )}
    </>
  )
}
